module.exports = __webpack_public_path__ + "img/ync-icon.1caa7e56.png";